import produce from 'immer'
import { SET_PROFILES } from './actionTypes'

export const initialState = {
  trips: {
    data: [],
    count: null,
  },
}

const profileReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_PROFILES:
        draft.profiles = action.data
        break
    }
  })

export default profileReducer
